/**
 * Module-level flag: true while the right panel is being drag-resized.
 * Expensive width observers (the Konva timeline renderers and UDR row tree)
 * check it to skip per-pixel re-layouts during the drag; usePanelDrag clears
 * it and fires a window resize event on release so they re-measure exactly
 * once at the final width.
 */
let dragging = false;

export const setRightPanelDragging = (value: boolean) => {
  dragging = value;
};

export const isRightPanelDragging = () => dragging;
